import { compose } from '../styled-system';
import * as styledFunctions from './constants';
export var composed = function composed() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  return compose(...styles.map(style => styledFunctions[style]));
};
export var composedAllProps = compose(...Object.keys(styledFunctions).map(styleFun => styledFunctions[styleFun]));
//# sourceMappingURL=index.js.map